
import React from 'react';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { AdminDashboardContent } from '@/components/admin/AdminDashboardContent';

export default function AdminDashboard() {
  const { adminUser } = useAdminAuth();
  
  // Make sure we have a valid user object
  const userForDashboard = {
    id: adminUser?.id || '',
    email: adminUser?.email
  };

  return (
    <AdminLayout>
      <AdminDashboardContent adminUser={userForDashboard} />
    </AdminLayout>
  );
}
